export const MIN_ORDER_VOLUME = 0.01;

const FINANCIAL_PRECISION = 8;

const roundFinancialValue = (value) => Number(value.toFixed(FINANCIAL_PRECISION));

export const getAssetContractMultiplier = (asset) => {
    const configured = asset?.contract_multiplier;
    const multiplier = Number(configured);

    if ((typeof configured === 'number' || typeof configured === 'string') &&
        Number.isFinite(multiplier) && multiplier > 0) {
        return multiplier;
    }

    // Preserve compatibility with API responses that predate contract_multiplier.
    switch (asset?.type) {
        case 'INDEX':
        case 'MARKET_INDEX':
            return 100000;
        case 'STOCK':
            return 100;
        case 'COMMODITY':
            return ['brentoil', 'oil', 'ukoil'].includes(asset?.name?.toLowerCase()) ? 1000 : 100;
        default:
            return 1;
    }
};

export const normalizeOrderVolume = (volume) => {
    if (volume === null || volume === '') {
        return null;
    }

    const numericVolume = Number(volume);

    if (!Number.isFinite(numericVolume)) {
        return null;
    }

    return roundFinancialValue(Math.max(MIN_ORDER_VOLUME, numericVolume));
};

export const calculateVolumeFromMargin = (margin, leverage, openPrice, multiplier = 1) => {
    const numericMargin = Number(margin);
    const numericLeverage = Number(leverage);
    const numericOpenPrice = Number(openPrice);
    const numericMultiplier = Number(multiplier);

    if (
        !Number.isFinite(numericMargin) ||
        !Number.isFinite(numericLeverage) ||
        !Number.isFinite(numericOpenPrice) ||
        !Number.isFinite(numericMultiplier) ||
        numericMargin < 0 ||
        numericLeverage <= 0 ||
        numericOpenPrice <= 0 ||
        numericMultiplier <= 0
    ) {
        return null;
    }

    return roundFinancialValue(
        Math.max(MIN_ORDER_VOLUME, numericMargin * numericLeverage / (numericOpenPrice * numericMultiplier))
    );
};

export const calculateMarginFromVolume = (volume, leverage, openPrice, multiplier = 1) => {
    const normalizedVolume = normalizeOrderVolume(volume);
    const numericLeverage = Number(leverage);
    const numericOpenPrice = Number(openPrice);
    const numericMultiplier = Number(multiplier);

    if (
        normalizedVolume === null ||
        !Number.isFinite(numericLeverage) ||
        !Number.isFinite(numericOpenPrice) ||
        !Number.isFinite(numericMultiplier) ||
        numericLeverage <= 0 ||
        numericOpenPrice <= 0 ||
        numericMultiplier <= 0
    ) {
        return null;
    }

    return roundFinancialValue(normalizedVolume * numericOpenPrice * numericMultiplier / numericLeverage);
};
